import { TAppealGrade } from 'feature/appeals/type'
import { Rating } from 'ui'
import { ModalCloseButton } from 'widget/ModalCloseButton/ModalCloseButton'

import style from './ModalFeedback.module.scss'

type TModalFeedback = {
  onClose: () => void
  grade: TAppealGrade
  title?: string
}

// модальное окно с отзывом пользователя

export function ModalFeedback({ onClose, grade, title }: TModalFeedback) {
  return (
    <div className={style.modalFeedback}>
      <span className='h1'>{title}</span>
      <ModalCloseButton onClose={onClose} showOnMobile />

      <div className={style.ratingBlock}>
        <Rating className={style.rating} value={grade?.value} readOnly />
      </div>

      <span className={style.comment}>{grade?.comment}</span>

      {!!grade.files?.length && (
        <div className={style.fileList}>
          {grade.files.map(file => (
            <div className={style.file} key={file.url}>
              <div className={style.fileInf}>
                <img src={file.url} alt={file.filename} />
                <div className={style.fileTextInf}>
                  <span className={style.fileName}>{file.filename}</span>
                  <span className='caption'>{file.size}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
